import { render, staticRenderFns } from "./bill-num-edit.vue?vue&type=template&id=37dd2a5c&scoped=true&"
import script from "./bill-num-edit.vue?vue&type=script&lang=js&"
export * from "./bill-num-edit.vue?vue&type=script&lang=js&"
import style0 from "./bill-num-edit.vue?vue&type=style&index=0&id=37dd2a5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd2a5c",
  null
  
)

export default component.exports